module.exports = __webpack_public_path__ + "media/img/frontend_application/myhosting/urgent_request-56193d30a41a9062e0c9fe4384dc9194.png";